import { styled, Typography } from '@mui/material'

import { ITableColumn } from '@/components/UI/DataTable/TableHead'
import { Copy } from '@/components/UI/Copy'
import { MaskedNumber } from '@/components/UI/MaskedNumber'
import { IFinancialAccount } from '@/types'
import { formatAmount } from '@/utils/common'

// Drawn at the table's text size. The account ID may break anywhere so it wraps inside its column
// instead of widening the table past the card.
const copyTextStyle = { fontSize: '14px', lineHeight: '20px' }
const idTextStyle = { ...copyTextStyle, wordBreak: 'break-all' }

// Fixed widths lay the table out to the card's width, as the connection details table above it is.
export const financialAccountColumns: ITableColumn<IFinancialAccount>[] = [
  {
    key: 'name',
    id: 'name',
    label: 'Nickname',
    enableSorting: true,
    width: '18%',
    render: (_v, r) => <StyledText>{r.name}</StyledText>,
  },
  {
    key: 'number',
    id: 'number',
    label: 'Account Number',
    align: 'right',
    enableSorting: true,
    width: '15%',
    render: (_v, r) => (
      <Copy
        value={r.number}
        displayValue={<MaskedNumber value={r.number} />}
        align="right"
        textStyle={{ ...copyTextStyle, fontVariantNumeric: 'tabular-nums' }}
      />
    ),
  },
  {
    key: 'id',
    id: 'id',
    label: 'Account ID',
    enableSorting: true,
    width: '27%',
    render: (_v, r) => <Copy value={r.id} textStyle={idTextStyle} />,
  },
  {
    key: 'productType',
    id: 'productType',
    label: 'Product',
    enableSorting: true,
    width: '14%',
    render: (_v, r) => <StyledText>{r.productType}</StyledText>,
  },
  {
    key: 'availableFunds',
    id: 'availableFunds',
    label: 'Available Funds',
    align: 'right',
    enableSorting: true,
    width: '14%',
    render: (_v, r) => <StyledText>{formatAmount(r.availableFunds)}</StyledText>,
  },
  {
    key: 'balance',
    id: 'balance',
    label: 'Balance',
    align: 'right',
    enableSorting: true,
    width: '12%',
    render: (_v, r) => <StyledText>{formatAmount(r.balance)}</StyledText>,
  },
]

const StyledText = styled(Typography)(({ theme }) => ({
  fontFamily: 'Inter',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '20px',
  textAlign: 'inherit',
  color: theme.palette.secondary.main,
  fontVariantNumeric: 'tabular-nums',
  wordBreak: 'break-word',
}))
